import { lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import SplashScreen from "src/components/splash-screen";
import { PATH_AFTER_LOGIN } from "src/config-global";

import { authRoutes } from "./auth";
import { mainRoutes } from "./main";
import { dashboardRoutes } from "./routes";

const TruckVisualPublicPage = lazy(() => import("./public/truck-visual-public-page"));

// ----------------------------------------------------------------------

export default function Router() {
	return useRoutes([
		{
			path: "/",
			element: <Navigate replace to={PATH_AFTER_LOGIN} />,
		},

		// Public routes (no auth)
		{
			path: "public/truck-visual",
			element: (
				<Suspense fallback={<SplashScreen />}>
					<TruckVisualPublicPage />
				</Suspense>
			),
		},

		// Auth routes
		...authRoutes,

		// Dashboard routes
		...dashboardRoutes,

		// Main routes
		...mainRoutes,

		// No match 404
	]);
}
